import { convertPerToEn } from "../../utils/helpers";

/* Turns whatever the owner pasted into the invite box into a clean list.
 *
 * People paste from a contacts app, a group chat or a spreadsheet, so the
 * separators are unpredictable: newlines, commas (both kinds), semicolons,
 * tabs, or just spaces. Numbers arrive with a country code, with dashes, with
 * Persian digits, and duplicated. All of that is normalised here rather than in
 * the component, so the step only has to deal with two lists.
 *
 * @returns {{ valid: string[], invalid: string[] }}
 */
export const parseMobiles = (raw) => {
  const chunks = convertPerToEn(String(raw || ""))
    .split(/[\s,،;؛\n\r\t]+/)
    .map((chunk) => chunk.replace(/[-().]/g, "").trim())
    .filter(Boolean);

  const valid = [];
  const invalid = [];

  chunks.forEach((chunk) => {
    const digits = chunk
      .replace(/^\+?0{2}98/, "0")
      .replace(/^\+98/, "0")
      .replace(/^98(?=9\d{9}$)/, "0")
      .replace(/^9(?=\d{9}$)/, "09");

    if (/^09\d{9}$/.test(digits)) {
      if (!valid.includes(digits)) valid.push(digits);
    } else {
      invalid.push(chunk);
    }
  });

  return { valid, invalid };
};

export default parseMobiles;
